module.exports = {
  "wxc-noticebar": {
    "width": 750,
    "paddingTop": 10,
    "paddingBottom": 10,
    "paddingLeft": 24,
    "backgroundColor": "#FFF7D6",
    "borderBottomWidth": 1,
    "borderTopWidth": 1,
    "borderColor": "#FFEEAE",
    "borderStyle": "solid",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "noticebar-content": {
    "color": "#EE9900",
    "fontSize": 26,
    "lineHeight": 36,
    "width": 592,
    "textOverflow": "ellipsis"
  },
  "more-click-content": {
    "width": 64,
    "alignItems": "center",
    "justifyContent": "center"
  },
  "mode-ICON": {
    "width": 32,
    "height": 32
  },
  "type-ICON": {
    "width": 32,
    "height": 32
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-469d53bf!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-noticebar/index.vue
// module id = 109
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28